import APITemplate from '@api/APITemplate'
import { diffTimeMinutes, formatQueryParams } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { crm } from '@modules/crm/constants/URL'

class APICrmClientsTasks extends APITemplate {
  constructor() {
    super()

    this.reqCarregar = null
  }

  // eslint-disable-next-line max-statements
  async carregar({ forceUpdate = false, filters = null, save = true } = {}) {
    if (this.reqCarregar) {
      return this.reqCarregar
    }
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['crm/clientsTasksLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['crm/clientsTasks']
      }
    }

    if (store.getters['crm/clientsTasksLoading']) {
      return store.getters['crm/clientsTasks']
    }

    const loadingActions = {
      true: 'crm/setClientsTasksLoading',
      false: 'crm/setClientsTasksLoadingNoSave',
    }

    store.dispatch(loadingActions[save], true)

    const params = {}
    if (filters && typeof filters === 'object') {
      params.filters = JSON.stringify({ ...filters })
    }

    this.reqCarregar = con.get(crm.clientsTasks + formatQueryParams(params))
    const r = await this.reqCarregar

    if (r && r.status === 200 && save) {
      const data = r.value.grupos || []
      const summaryData = r.value.totais || {}
      store.dispatch('crm/setClientsTasks', data)
      store.dispatch('crm/setClientsTasksSummary', summaryData)
    } else if (save) {
      store.dispatch('crm/setClientsTasks', [])
      store.dispatch('crm/setClientsTasksSummary', {})
    }

    store.dispatch(loadingActions[save], false)

    this.reqCarregar = null

    return r || {}
  }

  // Fetch de tarefas de 1 cliente (id_cliente_app). Não dispara mutação — controller faz o upsert.
  // NÃO envia filtro de status: o backend já descarta tarefas concluídas via
  // is_legacy_open_status quando nenhum status é informado (mesmo comportamento
  // do carregar()). Enviar status: 'pendente' (string legada) quebrava o filtro,
  // pois o enum atual da pm_task é todo/doing/done — nunca "pendente" — e o
  // backend comparava o valor cru, descartando todas as tarefas do cliente.
  async carregarCliente({ idClienteApp, filters = null } = {}) {
    if (!idClienteApp) {
      return {
        status: 400,
        message: 'Cliente inválido.',
      }
    }

    const params = {}
    const mergedFilters = {
      ...(filters && typeof filters === 'object' ? filters : {}),
      id_cliente_app: idClienteApp,
    }
    params.filters = JSON.stringify(mergedFilters)

    const r = await con.get(crm.clientsTasks + formatQueryParams(params))
    return (
      r || {
        status: 500,
        message: 'Erro ao carregar tarefas do cliente.',
      }
    )
  }

  async changeFavorite({ item }) {
    if (!item) {
      return {
        status: 400,
        message: 'Dados inválidos.',
      }
    }

    const { id_cliente_app, id_favorito_profissional, favorito } =
      item.cliente || {}

    const dado = {
      id_cliente_app,
    }

    const data = {
      data: JSON.stringify(dado),
    }

    let r

    if (favorito) {
      r = await con.post(crm.clientsFavorites, data)
    } else {
      r = await con.delet(crm.clientsFavorites + `/${id_favorito_profissional}`)
    }

    if (r && r.status === 200) {
      const value = r.value[0] || r.value || {}

      const payload = {
        id_cliente_app,
        favorito,
        id_favorito_profissional: value.id || id_favorito_profissional || null,
      }
      store.dispatch('crm/addClientsTasks', payload || {})
    }

    return (
      r || {
        status: 500,
        message: 'Erro ao mudar favorito.',
      }
    )
  }
}

const apiCrmClientsTasks = new APICrmClientsTasks()
export { apiCrmClientsTasks }
